import { render, staticRenderFns } from "./CustomOrderForm.vue?vue&type=template&id=25557e69&scoped=true"
import script from "./CustomOrderForm.vue?vue&type=script&lang=ts"
export * from "./CustomOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomOrderForm.vue?vue&type=style&index=0&id=25557e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25557e69",
  null
  
)

export default component.exports